import { isAbsoluteUrl } from "@/utils/apiUrl";

export const BASE_ENDPOINT = "filters/data";

/**
 * Endpoint suffix for the unified dataset data endpoint. Shared by the table,
 * plots and map views so they all hit the same endpoint with the same shape.
 */
export const buildDataEndpointSuffix = (
  datasetName: string,
  endpointPrefix?: string,
) =>
  isAbsoluteUrl(endpointPrefix)
    ? `${BASE_ENDPOINT}?dataset_type=${encodeURIComponent(datasetName)}`
    : `${BASE_ENDPOINT}/?dataset_type=${encodeURIComponent(datasetName)}`;
